import { RetryPromiseHook } from './retryCallback.types'

export const retryPromiseCallback: RetryPromiseHook = (callback, conditionalCallback) => {
  return callback().then(response => {
    if (conditionalCallback(response)) return retryPromiseCallback(callback, conditionalCallback)
    return response
  })
}
